<template>
 <div class="box">

        <van-dropdown-menu>
        <van-dropdown-item v-model="selectGrade" :options="gradeList" @change="changeGrade"/>
        <van-dropdown-item v-model="selectClass" :options="classList" @change="changeClass" />
        </van-dropdown-menu>
    <!-- inset -->
<!-- ${item.status}  -->
     <!-- <div class="venue-select">
 <van-cell-group >
<van-cell :title="item.name" :value="item.snCode" 
  :label="`${item.sex} ${['无人脸','有人脸'][item.haveFace]}  ${activityFil[item.activity]}`" v-for="(item,i) in PersonInfoList" :key="i"/>
</van-cell-group>
  </div> -->


<div class="box_top">
    <!-- <van-sticky> -->
            <div class="box_body" >
                <div class="box_body_li" v-for="(item,i) in testStudentGroupList" :key="i" :class="item&&!!+item.isFinish?'greenBGC':''">
                    <van-icon class="iconfont mask" class-prefix="icon" :name="`16gl-${i+1}`" style=""  size="50px"></van-icon>
                    <div class="lef_text">
                        <div v-show="item&&!!+item.isFinish">{{item&&item.finishSeconds}}</div>
                        <div>{{item&&item.name}}</div>
                        <!-- <div v-show="!item||!item.isFinish">{{item&&item.prompt_ready}}</div>
                        <div v-show="item&&item.isFinish">{{item&&item.prompt_test}}</div> -->
                    </div>
                </div>
           
            </div>
        <!-- </van-sticky> -->
    
<!-- inset -->
<div class="box_List">
<van-cell-group inset >
<van-cell center  border clickable  v-for="(item,i) in PersonInfoList" :key="i"  :title="`${item.name} `" 
:label="`${item.sex} ${['无人脸','有人脸'][item.haveFace]}  ${activityFil[item.activity]}`"  @click="onStudentCell(item)">
  <template #right-icon>
    <van-icon name="plus"  />
  </template>
   <template #title>
    <span class="custom-title" style="margin-right:8px;">{{item.name}}</span>
    <van-tag type="success"  v-show="item.selected">已上场</van-tag>
  </template>
   <template #default>
    <span class="custom-title" style="margin-right:8px;">{{item.score}}</span>
  </template>
  
</van-cell>
</van-cell-group>
</div>

</div>

<div class="box_foot" >
    <div class="box_foot_text">
        
            <!--<div> <van-count-down
                ref="countDown"
                millisecond
                :time="60000"
                :auto-start="false"
                format="ss:SSS"
                @finish="finish"
                />

                <van-count-down :time="60000" ref="countDown" :auto-start="false" millisecond @finish="finish" format="ss:SS">
                <template #default="timeData">
                    <span class="block">{{ timeData.hours  }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{ timeData.minutes }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{ timeData.seconds }}</span>
                </template>
                </van-count-down> </div>-->

        
        <div style="font-size:24px;">{{currentStatusMap[+groupInfoData.currentStatus]}}</div>
     
    </div>

    <!-- -->
    <div class="box_btn" style="margin-bottom:10px;">
        <van-button   size="small" round color="#00cc33"  style="width:25%;" :loading='loading' :disabled ='+this.groupInfoData.currentStatus==2?false:true'  @click="createGroup">创建组</van-button>
        <van-button   size="small" round color="#00cc33"  style="width:25%;" :loading='loading' :disabled ='+this.groupInfoData.currentStatus==0?false:true' @click="startTest">开始</van-button>
    </div>         

     <div class="box_btn">
        <van-button   size="small" round color="#ff3333" style="width:25%;" @click="clearGroup"  >清除异常</van-button>
        <van-button   size="small" round color="#ff3333" style="width:25%;" @click="endGroup"  :disabled ='+this.groupInfoData.currentStatus==1?false:true'>结束测试</van-button>
        <van-button   size="small" round color="#ff3333" style="width:25%;" :disabled ='+this.groupInfoData.currentStatus==1?false:true' @click="callBackGroup">召回</van-button>
        <van-button   size="small" round type="warning" style="width:25%;"  :disabled ='+this.groupInfoData.currentStatus==2?false:true' @click="clearTestGroupList">清空人员</van-button>
    </div>     
</div>


 </div>
</template>

<script>
import req from '@/utils/request2.js';
export default {
  name: 'SelectVenue',
  data() {
    return {
      selectedVenue: '' || '', // 支持从 Vuex 恢复
      selectedData:{},
      venues: [ ],
    gradeList:[],
    selectGrade:'',
    PersonInfoList:[],
    activityPersonInfoList:[],
    activityFil:["非活跃状态","活跃状态"],
    classList:[],
    selectClass:'',
    outdoorRunnControlData:{},
            testStudentGroupList:[],
groupInfoData:{},
currentStatusMap:['组别已创建','组别进行中','组别结束','异常',],
 timer: null,



         studentList:[],
            globalFilter:{},
            loading:false,
            startBtnDisabled:false,
            project:{},
            testGroupData:{},
            testGroupListLength:0,
            leftBoxWidth:'25%',
            rightBoxWidth:'75%',
            timer:null,
            machineStatus:{},
            machine_statusMap:['空闲','准备中','测试中','异常',],
            // 准备定时器
            ReadyTimer:null,
            // 成绩定时器
            TestTimer:null,
            // 测试记录 
            testGroupDataList:[],
            startAudioPlay:'',
            endAudioPlay:'',
    }
  },
  watch: {
    // 一旦选中，立即提交到 Vuex（可选，也可在 goNext 时提交）
    selectedVenue(newVal) {
    //   if (newVal) {
    //     this.$store.commit('setVenue', newVal)
    //   }
    }
  },
    beforeDestroy() {
    // 页面销毁前清除定时器
    this.clearTimer()
  },
  async mounted () {
    this.outdoorRunnControlData = JSON.parse(localStorage.getItem("outdoorRunnControlData"))
    await this.init()
    this.testStudentGroupList.length = 4
    // 查询当前区域组别详细信息
    this.getGroupInfo()
    this.startTimer()

  },
  methods: {
      clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
     startTimer() {
      // 立即执行一次
      if(this.timer){
        return
      }
      // 设置定时器，每5秒调用一次
      this.timer = setInterval(() => {
      this.getGroupInfo()
      }, 1000)
    },
    changeGrade(val){
        console.log(val);
        this.getClassList()
    },
    changeClass(val){
        console.log(val);
        this.getPersonInfoList()
        
    },
    clickVenue(item){
        this.selectedData = item
        this.selectedVenue = item.name
        console.log(item);
        
    },


    
     async getGroupInfo(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getGroupInfo`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
          hideLoading:true

        }).then(res=>{
            if (res.status='00') {
            if(res.data==null){
            this.groupInfoData = {
                currentStatus:"2"
            }

            }else{
            this.groupInfoData = res.data
            if (res.data) {
                res.data?.groupUsers.forEach(el=>{
                   this.testStudentGroupList[+el.ranking] = el
                })
            }
            }
          
            }
        // this.$toast('操作成功');
        })
    },

    async init(){
        // let data = {}
       await req.get({
          url:`${this.outdoorRunnControlData.serveIp}/selectGrade`,
          data:{},
        }).then(res=>{
          console.log("sss",res);
           this.gradeList = []
          res?.data.forEach(el=>{
            this.gradeList.push({
            text: el, value:el
            })
          })
          if (this.gradeList.length>0) {
            this.selectGrade = this.gradeList[0].value
            this.getClassList()
          }
        // this.$toast('操作成功');
        })
    },
    async getClassList(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getClassList`,
          data:{
            grade:this.selectGrade
          },
        }).then(res=>{
          console.log("sss",res);
           this.classList = []
          res?.data.forEach(el=>{
            this.classList.push({
            text: el, value:el
            })
          })
          if (this.classList.length>0&&this.selectClass =='') {
            this.selectClass = this.classList[0].value
            this.getPersonInfoList()
          }
        // this.$toast('操作成功');
        })
    },

 async getPersonInfoList(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getPersonInfoList`,
          data:{
            projectCode:this.outdoorRunnControlData.projectCode,
            classId:this.selectClass
          },
        }).then(res=>{
          console.log("sss",res);
        //    this.classList = []
        //   res?.data.forEach(el=>{
        //     this.classList.push({
        //     text: el, value:el
        //     })
        //   })
          this.PersonInfoList = res.data
        //   if (this.classList.length>0) {
        //     this.selectClass = this.classList[0].value
        //   }
        // this.$toast('操作成功');
        })
    },
  
async createGroup() {
      this.$toast.loading({ message: '加载中...', duration: 0 })
      let userInfoList = []
      this.testStudentGroupList.forEach((el,i)=>{
        if(el!==null){
            userInfoList.push({...el,ranking:i})
        }
      })
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/createGroup`,
          data:{
           userInfoList:userInfoList,
           areaId:this.outdoorRunnControlData.VenueId,
           projectCode:this.outdoorRunnControlData.projectCode,
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){
            this.getGroupInfo()
            this.$notify({message:res.msg})
          }else{
            this.$notify({type:'warning',message:res.msg})
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },
//0 ： 组别创建1 ： 组别进行中2 ： 组别结束
async startTest() {
      this.$toast.loading({ message: '加载中...', duration: 0 })
   
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/startGroup`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
           groupId:this.groupInfoData.dataId,
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){
            this.getGroupInfo()
             this.startTimer()
            this.$notify({message:res.msg})
          }else{
            this.$notify({type:'warning',message:res.msg})
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },

    //0 ： 组别创建1 ： 组别进行中2 ： 组别结束
    // 召回
async callBackGroup() {
      this.$toast.loading({ message: '加载中...', duration: 0 })
   
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/callBackGroup`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
           groupId:this.groupInfoData.dataId,
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){
            this.getGroupInfo()
            this.$notify({message:res.msg})
          }else{
            this.$notify({type:'warning',message:res.msg})
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },
    // 关闭组
async endGroup() {
      this.$toast.loading({ message: '加载中...', duration: 0 })
   
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/endGroup`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
           groupId:this.groupInfoData.dataId,
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){
            this.getGroupInfo()
            this.$notify({message:res.msg})
          }else{
            this.$notify({type:'warning',message:res.msg})
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },
    // 清除异常
async clearGroup() {
      this.$toast.loading({ message: '加载中...', duration: 0 })
   
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/clearGroup`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
           groupId:this.groupInfoData.dataId,
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){
            this.clearTestGroupList()
            this.getGroupInfo()
            this.$notify({message:res.msg})
          }else{
            this.$notify({type:'warning',message:res.msg})
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },

    
  
        // 开始接口
        StartTestApi(){
    //  "project": "SitUp",		//项目编码
	// "test_id": "111",		//测试ID
	// "countdown": "4",		//准备时间（秒）
	// "max_test_time": "60"	//测试时间（秒）
            StartTest({
                test_id:this.testGroupData.testId,
                project:this.project.projectId,
                countdown:'4',
                max_test_time:'60'
            }).then(res=>{
                console.log('StartTestApi');



                // 播放音频
                 this.$refs.audio.pause()
                 this.$refs.audio.play()
                
                
                let  _this= this
                _this.$refs.audio.addEventListener('ended',listener);
                function listener() {
                    console.log("Ended");
                // 开始倒计时
                _this.$refs.countDown.start()
                   _this.$refs.audio.removeEventListener("ended", listener);
                }
                
                // 开始查询成绩定时器
                // this.QueryTest()
                
                
            })
        },
      
        clearTestGroupList(){
            this.clearTimer()
            this.testStudentGroupList=[]
            this.testStudentGroupList.length = 4
            localStorage.setItem('testStudentGroupList',[])
            this.PersonInfoList.forEach(el=>{
                this.$set(el,'selected',false)
            })
        },
        onStudentCell(item){
            if (+this.groupInfoData.currentStatus!==2) {
                this.$notify({type:'warning',message:'正在测试中...'})
                return
            }

            
          

            let selected = false
            var testGroupListLength = 0
            this.testStudentGroupList.forEach(el=>{
                if (el&&el.snCode!=='') {
                    testGroupListLength++
                }
                if (el&&el.snCode==item.snCode) {
                    selected = true
                }
                
            })

            if (selected) {
                this.$notify({type:'warning',message:'该学生已上场'})
                return
            }

            if (testGroupListLength==5) {
                this.$notify({type:'warning',message:'位置已满'})
                return
            }
            for (let i = 0; i < this.testStudentGroupList.length; i++) {
                const el = this.testStudentGroupList[i];
                if (!el||el.studentId=='') {
                    this.$set(item,'selected',true)
                    this.$set(item,'ready',false)
                    this.testStudentGroupList[i] = item
                    break
                }
            }
            localStorage.setItem('testStudentGroupList',this.testStudentGroupList)
        },
   
  }
}
</script>

<style lang="less" scoped>
.box{
    position: relative;
    .box_top{
    display: flex;

    }
    .box_body{
        width: v-bind(leftBoxWidth);
        // z-index: 99;
        background-color: #fff;
        .box_body_li{
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            height: 15%;
            width: 100%;
            font-size: 24px;
            font-weight: 500;
            border-bottom:1px solid #f7f3f3;
            .lef_text{
              font-size: 20px;

            }
        }
    }
    .box_List{
        width:80%;
        overflow: auto;
        height: calc(100vh - 200px);
        // height: 100vh;
        // height: calc(100% - 200px);
        ::v-deep .van-cell-group--inset{
            margin: 0 12px;
        }
        // padding-bottom: 170px;
    }
    .box_foot{
        position: fixed;
        // bottom: 100px;
        bottom: 0;
        height: 200px;
        background-color: #fff;
        width: 100%;
        border-radius: 20px 20px 0 0;
        .box_foot_text{
        // position: fixed;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-bottom: 24px;
        .colon {
            display: inline-block;
            margin: 0 8px;
            color: #ee0a24;
        }
        .block {
            display: inline-block;
            width: 36px;
            color: #fff;
            font-size: 24px;
            text-align: center;
            background-color: #ee0a24;
            border-radius: 8px;
        }
        }
    }
    .box_btn{
        display: flex;
        justify-content: space-evenly;
        align-items: center;

    }
    .mask{ position:fixed;  z-index:999; opacity: 0.25; }
    .redBGC{

    }
    .greenBGC{
        background-color: rgba(0, 128, 0, 0.514);
    }
}
</style>